import { AUTO_STEP_NAME, PRODUCTS } from 'domain/enums'
import { FEED_ITEM_TITLE } from 'lead/domain/constants'
import { normalizeCreditAnalysis, normalizeCreditPayment } from './normalizers'

const isDocumentStepOrInspectionStep = ({ name }) => {
  return (
    name === AUTO_STEP_NAME.DOCUMENTS ||
    name === AUTO_STEP_NAME.COLLATERAL_INSPECTION
  )
}

const mergeStepNameDocumentInspection = ({ lead }) => {
  return {
    ...lead,
    currentStep: {
      ...lead.currentStep,
      name: AUTO_STEP_NAME.DOCUMENTS_COLLATERAL_INSPECTION,
    },
  }
}

const leadsAdapter = ({ cursors, items }) => {
  const leadList = items.map(lead => {
    if (isDocumentStepOrInspectionStep({ name: lead.currentStep.name })) {
      return mergeStepNameDocumentInspection({ lead })
    }
    return lead
  })
  return { items: [...leadList], cursors }
}

const leadByIdAdapter = ({
  borrower,
  conditions,
  feeds,
  id,
  intendedCredit,
  productType,
  steps,
  creditAnalysis,
  payment,
}) => {
  const stepList = steps.reduce((acc, current) => {
    if (
      isDocumentStepOrInspectionStep({ name: current.name }) &&
      productType === PRODUCTS.AUTO
    ) {
      if (
        !acc.some(
          item => item.name === AUTO_STEP_NAME.DOCUMENTS_COLLATERAL_INSPECTION,
        )
      ) {
        acc.push({
          ...current,
          name: AUTO_STEP_NAME.DOCUMENTS_COLLATERAL_INSPECTION,
        })
      }
    } else {
      acc.push(current)
    }

    return acc
  }, [])

  const feedList = feeds.filter(feed =>
    Object.keys(FEED_ITEM_TITLE).includes(feed.name),
  )

  const creditApproved = normalizeCreditAnalysis(creditAnalysis)
  const creditPaid = normalizeCreditPayment(payment)

  return {
    borrower,
    conditions,
    feeds: feedList,
    id,
    intendedCredit,
    productType,
    steps: [...stepList],
    creditAnalysis: creditApproved,
    payment: creditPaid,
  }
}

export { leadsAdapter, leadByIdAdapter }
